import { PHONE_REGEX_PATTERN, START_WITH_SPACE } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const UserCreateSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>)
    .matches(START_WITH_SPACE, {
      message: <Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>,
    }),
  email: Yup.string()
    .trim()
    .max(255)
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_EMAIL')}</Translation>)
    .matches(START_WITH_SPACE, {
      message: <Translation>{(t) => t('VALIDATE.REQUIRED_EMAIL')}</Translation>,
    })
    .email(<Translation>{(t) => t('VALIDATE.VALID_EMAIL')}</Translation>),
  phone: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PHONE')}</Translation>)
    .matches(PHONE_REGEX_PATTERN, {
      message: <Translation>{(t) => t('VALIDATE.VALID_PHONE')}</Translation>,
    }),
  role: Yup.string().required(<Translation>{(t) => t('VALIDATE.REQUIRED_ROLE')}</Translation>),
  partner: Yup.string().when('role', {
    is: 'partner',
    then: Yup.string().required(<Translation>{(t) => t('VALIDATE.REQUIRED_PARTNER')}</Translation>),
  }),
  merchant: Yup.string().when('role', {
    is: 'merchant',
    then: Yup.string().required(<Translation>{(t) => t('VALIDATE.REQUIRED_MERCHANT')}</Translation>),
  }),
})

export default UserCreateSchema
